<template>
    <v-navigation-drawer v-model="drawer" :rail="false" :permanent="mdAndUp" :temporary="!mdAndUp"
        v-if="menu && menu.length > 0">
        <v-list density="compact" nav class="mt-1 ml-0 pl-0 mr-0 pr-0" v-model:opened="opened">
            <v-list-item v-for="(item, index) in vociSingole" :key="'s-' + index" :prepend-icon="item.img"
                :title="item.text" :active="isActive(item.link)" color="primary" rounded="lg" @click="naviga(item)" />

            <v-list-group v-for="gruppo in gruppi" :key="gruppo.nome" :value="gruppo.nome">
                <template #activator="{ props }">
                    <v-list-item v-bind="props" :prepend-icon="gruppo.icona" :title="gruppo.nome" rounded="lg" />
                </template>
                <v-list-item v-for="(item, index) in gruppo.voci" :key="index" :prepend-icon="item.img"
                    :title="item.text" :active="isActive(item.link)" color="primary" rounded="lg" @click="naviga(item)"
                    style="padding-left: 20px!important" />
            </v-list-group>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
export default {
    name: "LeftBarComponent",
    props: {
        menu: { type: Array, default: () => [] },
        modelValue: { type: Boolean, default: true },
    },
    emits: ["esci", "update:modelValue"],

    data() {
        return {
            drawer: this.modelValue,
            // Gruppi attualmente espansi (v-model:opened della v-list): il gruppo
            // contenente la pagina attiva viene aggiunto automaticamente (vedi watch
            // su $route.path), il resto è a discrezione dell'utente per la sessione.
            opened: [],
        };
    },

    computed: {
        // Vuetify 3 espone useDisplay() come composable puro: in Options API
        // replichiamo lo stesso comportamento leggendo direttamente $vuetify.display.
        mdAndUp() {
            return this.$vuetify.display.mdAndUp;
        },

        // Voci singole in cima, fuori da qualunque gruppo: l'ordine arriva già
        // corretto dal backend (ORDER BY ProgOrder), filter lo preserva.
        vociSingole() {
            return this.menu.filter((m) => !m.gruppo);
        },

        // Gruppi tematici comprimibili: ordine e icone fissi lato frontend. Un
        // gruppo senza voci per il ruolo corrente (filtro già applicato lato
        // backend) non viene mostrato. Nessun gruppo definito ancora: da popolare
        // quando si aggiungono sezioni al menu.
        gruppi() {
            const DEFINIZIONE = [];
            return DEFINIZIONE
                .map((g) => ({ ...g, voci: this.menu.filter((m) => m.gruppo === g.nome) }))
                .filter((g) => g.voci.length > 0);
        },
    },

    watch: {
        modelValue(val) {
            this.drawer = val;
        },
        drawer(val) {
            this.$emit("update:modelValue", val);
        },

        "$route.path": {
            immediate: true,
            handler() {
                this.apriGruppoAttivo();
            },
        },
        menu: {
            immediate: true,
            handler() {
                this.apriGruppoAttivo();
            },
        },
    },

    methods: {
        apriGruppoAttivo() {
            const gruppoAttivo = this.gruppi.find((g) => g.voci.some((item) => this.isActive(item.link)));
            if (gruppoAttivo && !this.opened.includes(gruppoAttivo.nome)) {
                this.opened.push(gruppoAttivo.nome);
            }
        },

        isActive(link) {
            if (!link || !link.startsWith("/")) return false;
            return this.$route.path === link || this.$route.path.startsWith(link + "/");
        },

        naviga(item) {
            if (item.link && item.link.startsWith("/")) {
                this.$router.push({ path: item.link });
            } else if (item.link && item.link.startsWith("@")) {
                if (item.link == "@esci") this.$emit("esci");
            }
        },
    },
};
</script>
